import React from 'react';
import styled from 'styled-components';
import Loadable from 'react-loadable';

function Loading() {
  return <h3>Loading...</h3>;
}

const EditPlacement = Loadable({
  loader: () => import('../Container'),
  loading: Loading,
});

const EditPlacementContainer = () => (
    <EditPlacement />
)

EditPlacementContainer.propTypes = {
};

export default EditPlacementContainer;
